export function setUrlQueryParams(url: string, params: Record<string, unknown>): string {
  const normalizedParams = Object.keys(params)
    .filter((key) => params[key] != null)
    .reduce(
      (prev, key) => ({
        ...prev,
        [key]: String(params[key]),
      }),
      {} as Record<string, string>,
    );

  return `${url}?${new URLSearchParams(normalizedParams)}`;
}
